<div *ngIf="source === 'AWS'">
    <app-media-attachment
        #uploader
        type="file"
        [dropLabel]="dropLabel"
        [fileTooltip]="fileTooltip"
        (onUploadOrRemoveCompleted)="onMediaReady.emit($event[0])"
        [allowedMimeType]="allowedMimeType"
        (saving)="saving.emit($event)"
        [isCreateForm]="true"
        [displayMedias]="false"
        [isIconBtns]="false"
        [scope]="scope"
    ></app-media-attachment>
</div>
<div *ngIf="source === 'SERVER'">
    <app-menu-side-media-upload-img
        [allowedMimeType]="allowedMimeType"
        class="media-upload-img"
        (saving)="saving.emit($event)"
        (onMediaReady)="onMediaReady.emit($event)"
        [scope]="scope"
    >
    </app-menu-side-media-upload-img>
</div>
